/**
 * Confirmation modal for membership actions.
 *
 * Actions affecting many members and sending emails require explicit
 * confirmation before running. This component asks for it.
 * @module components/ControlPanel/ConfirmModal
 */

import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  confirm: {
    id: 'Confirm',
    defaultMessage: 'Confirm',
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel',
  },
});

interface ConfirmModalProps {
  open: boolean;
  title: string;
  content: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

/**
 * Confirm membership action.
 *
 * @param props Component props.
 * @returns Modal dialog asking for confirmation.
 */
const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  content,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const intl = useIntl();

  return (
    <Modal open={open} onClose={onCancel} size="small">
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>{content}</Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel} disabled={loading}>
          {intl.formatMessage(messages.cancel)}
        </Button>
        <Button onClick={onConfirm} loading={loading} primary>
          {intl.formatMessage(messages.confirm)}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmModal;
